module.exports = __webpack_public_path__ + "static/media/manufacturing-square.03fcc6e6.jpg";